import { BaseApi } from '@/main/baseApi';

import { DependentTableNames, DMS_MODULE, NAME, CUSTOMER_FILES, SUPPLIER_EDIT_HISTORY } from './constants';

class DodavatelProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	schemaUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case CUSTOMER_FILES:
				return `/${this.area}/${NAME}/CustomerFilesSchema`;
			case SUPPLIER_EDIT_HISTORY:
				return `/${this.area}/${NAME}/SupplierEditHistorySchema`;
			default:
				throw new Error(`schema for ${tableName} is not implemented yet`);
		}
	}

	tableUrl(tableName: DependentTableNames) {
		switch (tableName) {
			case CUSTOMER_FILES:
				return `/${this.area}/${NAME}/CustomerFilesRows`;
			case SUPPLIER_EDIT_HISTORY:
				return `/${this.area}/${NAME}/SupplierEditHistoryRows`;
			default:
				throw new Error(`data for ${tableName} is not implemented yet`);
		}
	}

	saveDodavatelFileDocument(fileList: any, ZakaznikId: null | number) {
		const file = new FormData();
		file.append('file', fileList.raw, fileList.name);
		return this.uploadMultipart(`/${DMS_MODULE}/${NAME}/SaveDocument?ZakaznikId=${ZakaznikId}`, file);
	}

	getDodavatelFileDocuments(fileId: number) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/GeCustomerFilestDocument?fileId=${fileId}`);
	}

	deleteDodavatelFileDocuments(fileId: number) {
		return this.post(`/${DMS_MODULE}/${NAME}/DeleteDocument?fileId=${fileId}`);
	}

	validateGSTINAndPAN(PAN: null | string, GSTIN: null | string, Id: number): any {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ValidateGSTINAndPAN?PAN=${PAN}&GSTIN=${GSTIN}&Id=${Id}`);
	}

	validateAbbreviation(Abbreviation: null | string, DodavatelId: number): any {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ValidateAbbreviation`, { Abbreviation, DodavatelId });
	}

	approveSupplierDetails(Id: null | number, ZakaznikId: null | number) {
		return this.post(`/${DMS_MODULE}/${NAME}/ApproveDetails?Id=${Id}&ZakaznikId=${ZakaznikId}`);
	}

	unApproveSupplierDetails(Id: null | number, SupplierRemarks: string, ZakaznikId: null | number) {
		return this.post(`/${DMS_MODULE}/${NAME}/UnApproveDetails?Id=${Id}&Remark=${SupplierRemarks}&ZakaznikId=${ZakaznikId}`);
	}
}
export const apiProvider = new DodavatelProvider();
